import shopifyGenericDefaults from '../shopify-generic/config.js';

const baseFitmentFields = shopifyGenericDefaults.fitmentSearch.baseFields;
const isHomePage = window.location.pathname === '/';

window.Convermax.removeRecentVehicle = (vehicle, e) => {
  e?.stopPropagation?.();
  e?.target?.closest?.('.cm_vehicle-widget_recent-vehicles_item')?.remove();

  window.Convermax.removeVehicle(vehicle);
};

window.Convermax.selectRecentVehicle = (vehicle) => {
  window.Convermax.setVehicle(vehicle, false);
  window.Convermax.updateVerifyFitmentWidget(window.Convermax.Shopify.getProductId());
};

function initFacetDialogButtonSticky() {
  const button = window.document.querySelector('.cm_facetDialogButton');
  if (!button || button.dataset.cmStickyInit) {
    return;
  }

  button.dataset.cmStickyInit = 'true';

  let stickyStart = 0;
  const update = () => {
    if (!button.classList.contains('cm_sticky')) {
      stickyStart = button.getBoundingClientRect().top + window.scrollY;
    }
    button.classList.toggle('cm_sticky', window.scrollY > stickyStart);
  };

  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
}

const AfterInit = () => {
  window.setTimeout(() => {
    initFacetDialogButtonSticky();
  }, 1000);
};

function updateCallback() {
  shopifyGenericDefaults.Widgets.find((w) => w.name === 'SearchResult')?.updateCallback();

  try {
    window._swat.initializeActionButtons('.cmRepeater_items');
  } catch {
    setTimeout(() => window._swat?.initializeActionButtons('.cmRepeater_items'), 1000);
  }
}

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  AfterInit,
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter(
      (w) =>
        !['SingleVehicleGarage', 'VehicleWidgetDialog', 'SearchVehicleWidget', 'SearchResult'].includes(
          w.name,
        ),
    ),
    {
      name: 'SearchResult',
      infiniteScrollDisabled: !!window.Convermax.config?.infiniteScrollDisabled,
      instantInfiniteScroll: !!window.Convermax.config?.instantInfiniteScroll,
      updateCallback,
    },
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
      columnBreakpoint: 850,
      fields: !!window.Convermax.config?.extraFieldsAsFilters && baseFitmentFields,
      isVehicleSelectionIsolated: !!window.Convermax.config?.isVehicleSelectionIsolated,
    },
    {
      ...shopifyGenericDefaults.Widgets.find((w) => w.name === 'VehicleWidgetDialog'),
      location: {
        id: 'cm_GarageDialog',
        class: 'GarageDialog',
      },
      doNotRedirectOnVehicleSelect: !isHomePage,
      globalVehicleDiscardEnabled: true,
      isAlwaysColumnLayout: true,
      isAutoVehicleSelectionDisabled: true,
      redirectUrl: isHomePage ? '/pages/search' : undefined,
    },
    {
      name: 'SingleVehicleGarage',
      location: { selector: '#cm-single-garage', class: 'cm_garage__single-vehicle' },
      template: 'fitmentSearch/singleVehicleGarage',
    },
  ],
};
